import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useContext } from 'react';
import { Icon } from '../../icon/index.js';
import { FCTheme } from '../../../theming/FCTheme.js';
import { StyledButton, StyledIcon } from './style.js';
var Button = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var buttonColor = _a.buttonColor,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b,
      _c = _a.isLoading,
      isLoading = _c === void 0 ? false : _c,
      primary = _a.primary,
      loadingIcon = _a.loadingIcon,
      icon = _a.icon,
      children = _a.children,
      fcStyle = _a.fcStyle,
      as = _a.as,
      rest = __rest(_a, ["buttonColor", "disabled", "isLoading", "primary", "loadingIcon", "icon", "children", "fcStyle", "as"]);

  var theme = useContext(FCTheme);
  var asProps = {};

  if (as === 'a') {
    asProps = {
      as: as,
      role: 'button'
    };
  }

  return /*#__PURE__*/React.createElement(StyledButton, __assign({
    ref: ref,
    icon: icon,
    buttonColor: buttonColor,
    disabled: disabled || isLoading,
    primary: primary,
    fcStyle: fcStyle,
    theme: theme.theme
  }, asProps, rest), isLoading && loadingIcon && /*#__PURE__*/React.createElement(React.Fragment, null, loadingIcon, " "), icon && !isLoading && /*#__PURE__*/React.createElement(StyledIcon, {
    className: "button-icon",
    fcStyle: fcStyle,
    primary: primary
  }, /*#__PURE__*/React.createElement(Icon, {
    title: "Icon Button",
    icon: icon
  })), children);
});
Button.displayName = 'Button';
export default Button;
export { Button };